export default "__VITE_ASSET__CYLop2oH__"